<!--销售订单收款-->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">电商平台</div>
                <el-select class="search-item" size="small" clearable @visible-change="platformVisibleChange($event)" @change="platformChange" v-model.trim="searchData.Platform">
                    <el-option v-for="item in platformList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                </el-select>
                <div class="search-name">来源店铺</div>
                <el-select
                    class="search-item"
                    style="width: 180px;"
                    size="small"
                    v-model="searchData.ShopIds"
                    filterable
                    clearable
                    reserve-keyword
                    multiple
                    collapse-tags 
                    @visible-change="shopVisibleChange($event)"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="optionItem in shopList"
                        :key="optionItem.Id"
                        :data-msg="optionItem"
                        :label="optionItem.Name"
                        :value="optionItem.Id"
                    ></el-option>
                </el-select>
                <div class="search-name">单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" placeholder="请输入"></el-input>
                <div class="search-name">业务员</div>
                <el-select
                    v-model="searchData.SIds"
                    filterable
                    clearable
                    multiple
                    collapse-tags 
                    placeholder="请选择"
                    @visible-change="siVisibleChange($event)"
                    class="search-item"
                    size="small"
                >
                    <el-option v-for="item in sIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">提交时间</div>
                <el-date-picker
                    size="small"
                    v-model="datetime2"
                    type="daterange"
                    style="width: 300px;"
                    class="search-item"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="onDate2TimeSelect"
                ></el-date-picker>
                <el-button style="margin-left: 10px;" icon="el-icon-search" size="small" class="search-btn btn-primary" @click="handleSearch()">查询 (Enter)</el-button>
                <el-button class="search-btn" size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                <el-button class="search-btn btn-primary"  size="small" @click="showSearchDialog()">更多条件</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">{{ permission.export }}</el-button>
                <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn"
                        @click="showTableSetDialog()">表格设置</el-button>     
            </div>
        </div>
        <div class="header-total">
            <div class="flex-between">
                <div>
                    <div>销售单数</div>
                    <div class="item-total">{{ headerData.SOCount }}</div>
                </div>
                <div>
                    <div>商品销售数</div>
                    <div class="item-total">{{ headerData.SGoodCount }}</div>
                </div>
                <div>
                    <div>销售总额</div>
                    <div class="item-total">{{ headerData.SOTotal }}</div>
                </div> 
                <div>
                    <div>退货单数</div>
                    <div class="item-total">{{ headerData.STOCount }}</div>
                </div>               
                <div>
                    <div>退货商品数</div>
                    <div class="item-total">{{ headerData.STGoodCount }}</div>
                </div>               
                <div>
                    <div>退货总额</div>
                    <div class="item-total">{{ headerData.STOTotal}}</div>
                </div>               
                <div>
                    <div>优惠金额</div>
                    <div class="item-total">{{ headerData.DiscountAmount }}</div>
                </div>               
                <div>
                    <div>运费</div>
                    <div class="item-total">{{ headerData.TransTotal }}</div>
                </div>               
                <div>
                    <div>合计</div>
                    <div class="item-total">{{ headerData.Total }}</div>
                </div>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" :tableCode="tableCode" border style="width: 100%" @selection-change="handleSelectionChange" row-key="EntpCusOId">
                    <el-table-column type="selection" reserve-selection width="50" fixed="left"></el-table-column>
                    <template v-for="(col, index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-if="col.ColumnCode == 'OrderCode'"
                        >
                            <template slot-scope="scope">
                                <span @click="gotoOrderDetail(scope.row)" style="color: #409EFF;"> {{ scope.row.OrderCode }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'OrderType'"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.OrderType == 0" class="color-blue">销售订单</span>
                                <span v-else class="color-pink">销售售后</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'OrderAmount'"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.OrderType == 0">{{ scope.row.OrderAmount }}</span>
                                <span v-else>{{ scope.row.OrderAmount > 0 ? '-' + scope.row.OrderAmount : 0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'CalcAmount'"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.OrderType == 0">{{ scope.row.CalcAmount }}</span>
                                <span v-else>{{ scope.row.CalcAmount > 0 ? '-' + scope.row.CalcAmount : 0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'StateName'"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.StateName == '已出仓' || scope.row.StateName == '已入仓'" class="color-pink">{{ scope.row.StateName }}</span>
                                <span v-else-if="scope.row.StateName == '部分出仓'" class="color-og">{{ scope.row.StateName }}</span>
                                <span v-else>{{ scope.row.StateName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'CollectionState'"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.CollectionState == '已收款' || scope.row.CollectionState == '已退款'" class="color-blue">{{ scope.row.CollectionState }}</span>
                                <span v-else>{{ scope.row.CollectionState }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'ImgList'"
                        >
                            <template slot-scope="scope">
                                <!-- <div v-for="item in scope.row.ImgList" :key="item">
                                    <img :src="downloadUrl + item + '?imageView2/2/w/200'" style="width: 50px;height: 50px;" alt="" @click="onPreview(scope.row.ImgList)" />
                                </div> -->
                                <div v-if="scope.row.ImgList.length > 0">
                                    <img :src="downloadUrl + scope.row.ImgList[0] + '?imageView2/2/w/200'" style="width: 50px;height: 50px;" alt="" @click="onPreview(scope.row.ImgList)" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column width="80px" fixed="right" label="操作">
                        <template slot-scope="scope">
                            <div class="ops-ctn" v-if="scope.row.IsDelivery && scope.row.CollectionState != '不需收款'">
                                <el-button size="mini" v-if="!scope.row.IsPay && permission.apply" type="text" @click="showReceipt(scope.row)">确认收款</el-button>
                                <el-button size="mini" v-else-if="scope.row.IsPay && permission.cancel" style="color: red" type="text" @click="cancel(scope.row)">状态回退</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
                <div class="dialog-content" v-if="searchSetVisible">
                    <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="更多条件"
                :visible.sync="dialogSearchVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-order-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogSearchVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="电商平台">
                            <el-select
                                style="width: 100%"
                                size="small"
                                v-model="searchData.Platform"
                                filterable
                                clearable
                                reserve-keyword
                                @visible-change="platformVisibleChange($event)"
                                @change="platformChange"
                                placeholder="请选择"
                            >
                                <el-option label="全部" value></el-option>
                                    <el-option v-for="item in platformList"
                                        :key="item.Id"
                                        :label="item.Name"
                                        :value="item.Name"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源店铺">
                            <el-select
                                style="width: 100%"
                                size="small"
                                v-model="searchData.ShopIds"
                                filterable
                                clearable
                                reserve-keyword
                                multiple
                                collapse-tags 
                                @visible-change="shopVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="optionItem in shopList"
                                    :key="optionItem.Id"
                                    :data-msg="optionItem"
                                    :label="optionItem.Name"
                                    :value="optionItem.Id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称">
                            <el-select
                                style="width: 100%"
                                size="small"
                                v-model="searchData.CusName"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="客户名称/电话"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span v-if="item.CallNum" class="phone">
                                            {{ ` ( 电话：${item.CallNum} )` }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号">
                            <el-input size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                        </el-form-item>
                        <el-form-item label="平台单号">
                            <el-input size="small" v-model.trim="searchData.DSOrderCode" v-filter-special-char="searchData.DSOrderCode" placeholder="平台单号"></el-input>
                        </el-form-item>
                        <el-form-item label="支付方式">
                            <el-select
                                class="search-item"
                                v-model="searchData.PayType"
                                @visible-change="payVisibleChange($event)"
                                placeholder="请选择"
                                style="width: 100%"
                                clearable
                                size="small"
                            >
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="仓库">
                            <el-select
                                class="search-item"
                                v-model="searchData.StoId"
                                @visible-change="warehouseVisibleChange($event)"
                                placeholder="请选择"
                                style="width: 100%"
                                clearable
                                size="small"
                            >
                                <el-option
                                    v-for="optionItem in warehouseList"
                                    :key="optionItem.WarehouseId"
                                    :label="optionItem.WarehouseName"
                                    :value="optionItem.WarehouseId"
                                >
                                    <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                    <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据类型">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData.OrderType"
                                placeholder="请选择"
                            >
                                <el-option label="全部" value=""></el-option>
                                <el-option label="销售单" value="0"></el-option>
                                <el-option label="销售售后单" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务员">
                            <el-select v-model="searchData.SIds" size="small" style="width: 100%" multiple collapse-tags filterable placeholder="请选择" clearable>
                                <el-option v-for="item in sIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流状态">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData.OutWarehouseState"
                                placeholder="请选择"
                            >
                                <el-option label="全部" value=""></el-option>
                                <el-option label="未出仓" value="0"></el-option>
                                <el-option label="部分出仓" value="1"></el-option>
                                <el-option label="已出仓" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收款状态">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData.State"
                                placeholder="请选择"
                            >
                                <el-option label="全部" value=""></el-option>
                                <el-option label="未收款" value="0"></el-option>
                                <el-option label="已收款" value="1"></el-option>
                                <el-option label="不需要收款" value="2"></el-option>
                                <el-option label="已收定金" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input size="small" v-model.trim="searchData.Remark" placeholder="备注"></el-input>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime3"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate3TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="查询公式">
                            <el-radio-group v-model="searchData.SearchType">
                                <el-radio :label="0">左等</el-radio>
                                <el-radio :label="1">全等</el-radio>
                                <el-radio :label="2">包含</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="申请收款" :visible.sync="receiptVisible" width="800px">
                <div class="dialog-content" v-if="receiptVisible">
                    <receipt ref="receipt" @closeReceipt="closeReceipt" :orderData="orderData" :orderType="orderData.OrderType"></receipt>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>  
            <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="previewList" :z-index="99999" />
        </template>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import tableSets from '@/components/common/tableSets_v2.vue';
import receipt from '@/views/business/ecPlatform/receipt_ec';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { elTableColumn, breadcrumb, tableSets, receipt, ElImageViewer },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            noData: false,
            downloadUrl: this.$util.QN_URL_BASE,
            saveLoading: false,
            searchData: {
                Platform:'',
                ShopIds:[],
                CusName:'',
                OrderCode:'',
                DSOrderCOde:'',
                PayType:'',
                StoId:'',
                OrderType:'',
                // SId: userMsg.EmployeeId,
                SIds:[],
                OutWarehouseState:'',
                State:'0',
                Remark:'',
                StartDate:'',
                EndDate:'',
                CStartDate:'',
                CEndDate:'',
                FDStartDate:'',
                FDEndDate:'',
                SearchType:2,
                page: 1,
                limit: 15,
            },
            headerData:{
                SOCount: 0,
                SGoodCount: 0,
                SOTotal: 0,
                STOCount: 0,
                STGoodCount:0,
                STOTotal: 0,
                DiscountAmount: 0,
                TransTotal: 0,
                Total: 0
            },
            tableData: [],
            multipleSelection:[],
            idList:[],
            tableDataLength: 0,
            permission: {},
            dialogSearchVisible: false,
            isStartSearch:false,
            platformList: [],
            shopList:[],
            sIdList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            datetime1:[],
            datetime2:[],
            datetime3:[],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            exportTotalCount: 0, 
            searchSetVisible:false,
            tableCode:'OrderGathering',
            isCanTBSet:false,
            columnShowSets:[],
            receiptVisible:false,
            orderData:{},
            previewList:[],
            showViewer:false,
            payWayList:[],
            warehouseList:[],
            searchLoading:false
        };
    },
    mounted() {        
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.datetime2.push(date1);

        //前一天设定的日期时间
        let year2, month2;
        d.setTime(d.getTime());
        [year2, month2] = [d.getFullYear(), d.getMonth(),];
        let date2 = new Date(year2, month2, 1, 0);
        this.datetime2.unshift(date2);

        this.searchData.CStartDate = date2;
        this.searchData.CEndDate = date1;

        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getSIdList();
        this.getSetsData();
        this.permission = this.$util.getPermission('ecSalesOrderGathering');
    },
    methods: {
        getConfigByCodes() {
            let that = this;
            let codes = ['ygsfkzdylb'];
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;                                   
                        }
                    }
                }
                that.getTableData();
            });
        },
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement_EC/GetSalesOrderGatheringList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data.DataList;
                    if(this.searchData.page == 1){
                        this.headerData = {
                            SOCount: data.SOCount,
                            SGoodCount: data.SGoodCount,
                            SOTotal: data.SOTotal,
                            STOCount: data.STOCount,
                            STGoodCount: data.STGoodCount,
                            STOTotal: data.STOTotal,
                            DiscountAmount: data.DiscountAmount,
                            TransTotal: data.TransTotal,
                            Total: data.Total
                        }
                        this.tableDataLength = res.count;
                    }
                })
                .catch(() => { });
        },
        getPlatformList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetPlatformList'
                })
                .then(res => {
                    if (res.data) {
                        this.platformList = res.data;
                    } else {
                        this.platformList = [];
                    }
                });
        },
        resetSearch() {
            this.searchData = {
                Platform:'',
                ShopIds:[],
                CusName:'',
                OrderCode:'',
                DSOrderCOde:'',
                PayType:'',
                StoId:'',
                OrderType:'',
                SIds:[],
                OutWarehouseState:'',
                State:'0',
                Remark:'',
                StartDate:'',
                EndDate:'',
                CStartDate:'',
                CEndDate:'',
                FDStartDate:'',
                FDEndDate:'',
                SearchType:2,
                page: 1,
                limit: 15,
            };

            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];

            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);
            this.datetime2.push(date1);

            //前一天设定的日期时间
            let year2, month2;
            d.setTime(d.getTime());
            [year2, month2] = [d.getFullYear(), d.getMonth()];
            let date2 = new Date(year2, month2, 1, 0);
            this.datetime2.unshift(date2);

            this.searchData.CStartDate = date2;
            this.searchData.CEndDate = date1;
            this.platformChange();
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        platformVisibleChange(event) {
            let that = this;
            if (event) {
                if(that.platformList.length > 1) return;
                that.getPlatformList();
            }
        },
        platformChange(val){
            let that = this;
            let index = that.platformList.findIndex(x=>x.Name == val);
            if(index > -1){
                that.shopList = [];
                that.ShopIds = [];
                that.searchLoading = true;
                that.$util.getPlatformShops(this.platformList[index].Id).then(data => {
                    that.shopList = data;
                    that.searchLoading = false;
                });
            }else{
                that.searchLoading = true;
                that.$util.getPlatformShops().then(data => {
                    that.shopList = data;
                    that.searchLoading = true;
                });
            }
        }, 
        shopVisibleChange(event) {
            let that = this;
            if (event) {
                if(that.shopList.length >= 1 || that.searchLoading) return;
                let id = that.searchData.Platform;
                that.$util.getPlatformShops(id).then(data => {
                    that.shopList = data;
                });
            }
        },
        payVisibleChange(event) {
            let that = this;
            if (event) {
                if(that.payWayList.length >= 1) return;
                this.$util.getPay().then(data => {
                    this.payWayList = data;
                });
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length >= 1) return;
                this.$util.getWarehouse(1).then(data => {
                    this.warehouseList = data;
                });
            }
        },
        handleSearch(){
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
        },
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.sIdList = data;
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.FDStartDate = val[0];
                this.searchData.FDEndDate = val[1];
            } else {
                this.searchData.FDStartDate = '';
                this.searchData.FDEndDate = '';
            }
        },
        showTableSetDialog() {
            if (this.tableCode) {
                this.searchSetVisible = true;
            }
        },
        closeDialog(edit) {
            this.searchSetVisible = false;
            if(edit){
                this.$router.go(0);
            }
        },
        gotoOrderDetail(row){
            if(row.OrderType == 0){
                this.$router.push(`/ecPlatform/ecSalesOrder/check?id=${row.EntpCusOId}`);
            }else{
                ///OrderType刚好是1
                this.$router.push(`/ecPlatform/ecReturnManage/check?type=${row.OrderType}&SReturnId=${row.EntpCusOId}&id=${row.STRsOrderId}`);
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
                this.getConfigByCodes();
            });
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 300;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.page = that.currtPage;
            
            that.$util
                .axiosPost({
                    url: '/api/RevenueManagement_EC/GetSalesOrderGatheringToExport',
                    data: reqData,
                })
                .then(resp => {
                    let data = resp.data;
                    if (that.currtPage == 1) {
                        if (data.totalCount == 0) {
                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.exportTotalCount = 0;
                            that.saveLoading = false;
                            that.showExportMsg = false;
                            that.$util.warningMsg('没有可导出的数据');
                            return;
                        }
                        that.exportTotalCount = data.totalCount;
                    }
                    that.saveCount += data.count;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.exportTotalCount);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.exportTotalCount <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/RevenueManagement_EC/ExportSalesOrderGathering',
                                hideLoading:true,
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.exportTotalCount = 0;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            })
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.exportTotalCount = 0;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        },
        // 显示收款
        showReceipt(row) {
            this.orderData = row;
            this.receiptVisible = true;
        },
        // 隐藏收款
        closeReceipt(id,type) {
            this.receiptVisible = false;
            if (id) {
                // this.getTableData();
                this.getOrderDetails(id,type);
            }
        },   
        cancel(row){
            this.loading = true;
            let type = row.OrderType;
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement_EC/ECOrderStateBack',
                    data: { EntpCusOId : row.EntpCusOId,OrderType : type }
                })
                .then(res => {
                    this.$util.successMsg('回退成功');
                    let index = this.tableData.findIndex(x=>x.EntpCusOId == row.EntpCusOId);
                    if(index > -1){
                        this.tableData[index].IsPay = false;
                        this.tableData[index].Paid = 0;
                        if(type == 0){
                            this.tableData[index].CollectionState = "未收款";
                        }else{
                            this.tableData[index].CollectionState = "未退款";
                        }
                        this.tableData[index].Remark2 = "";
                        this.tableData[index].ImgList = [];
                        this.tableData[index].ConfirmTime = "";
                    }

                    //this.getTableData();
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getOrderDetails(id,type) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_EC/GetUpOrderInfoById',
                    data: {
                        OrderId: id,
                        Type: type
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;

                    let index = this.tableData.findIndex(x=>x.EntpCusOId == id);
                    if(index > -1){
                        this.tableData[index].IsPay = true;
                        if(type == 0){
                            this.tableData[index].CollectionState = "已收款";
                        }else{
                            this.tableData[index].CollectionState = "已退款";
                        }
                        for (let i = 0; i < data.OrderImages.length; i++) {
                            this.tableData[index].ImgList.push(data.OrderImages[i].ImgUrl);
                        }
                        this.tableData[index].Paid = data.Paid;
                        this.tableData[index].Remark2 = data.Remark;
                        this.tableData[index].ConfirmTime = data.FDConfirmTime;
                    }

                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 关闭查看器
        closeViewer() {
            this.showViewer = false;
        },
        // 打开上传图片预览
        onPreview(row) {
            this.previewList = row.map(item => this.downloadUrl + item);
            this.showViewer = true;
        },    
    }
};
</script>
<style lang="less" scoped>
.header-total{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
    border: 1px solid #ebeef5;
    margin-bottom: 5px;
    .flex-between{
        width: 90%;
        display: flex;
        justify-content: space-between;
        
    }
    div{
        text-align: center;
    }
    .item-total{
        color: #303133;
        font-size: 20px;
        margin-top: 5px;
    }
}
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
.color-pink{
    color: #ff0097;
}
.color-blue{
    color: #0dbdae;
}
.color-og{
    color: #eea724;
}
//select多选超出选框隐藏样式
/deep/.el-select__tags-text {
   display: inline-block;
   max-width: 60px;//根据实际宽度调整
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

/deep/.el-tag__close.el-icon-close {
    top: -7px; // 清除下标的位置调整
}
</style>
